import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {isFabricWebview} from '~/common/utils/webview';

export const isProOrPartyPassUser = (subscriptionPlanName) =>
  [PLAN_NAME_PRO, PLAN_NAME_PARTY_PASS].includes(subscriptionPlanName);

export const MW_STEP_1_TEXT_EXPERIMENT_NAME = 'mw-step-1-text';

export const isInMwStep1TextVariation = (readOnly = true) =>
  evite.experiments.inVariation(MW_STEP_1_TEXT_EXPERIMENT_NAME, 'variant', false, readOnly);

export const GIFTING_UI_UPDATE_EXPERIMENT_NAME = 'test_step_3_gifting_ui_update';

export const isInNewGiftingUIVariation = (readOnly = true) =>
  !isFabricWebview() &&
  evite.experiments.inVariation(GIFTING_UI_UPDATE_EXPERIMENT_NAME, 'variant', false, readOnly);
